import { Util } from "./util.js";

const util = new Util();

export class Article {
	constructor(dom, wishlist, comboInfoForArticle = { comboType: "UNKNOWN" }, isArticleInTopicPage = false) {
		this.dom = dom;
		this.id = util.readFromDataAttribute(dom, "article_id");
		this.variationId = util.readFromDataAttribute(dom, "variation_id");
		this._variationsForArticle = JSON.parse(util.readFromDataAttribute(dom, "variation_ids"));
		this.position = parseInt(util.readFromDataAttribute(dom, "article_position"));
		this.comboType =
			comboInfoForArticle.comboType.charAt(0).toUpperCase() +
			comboInfoForArticle.comboType.slice(1).toLowerCase();
		this.isArticleInTopicPage = isArticleInTopicPage;
		this._setWishlistHeartDomState();
		this.wishlist = wishlist;
	}

	_setWishlistHeartDomState() {
		this._wishlistHeartDom = this.dom.querySelector(".combo_article--wishlistheart");
		this._onWishlist = this._wishlistHeartDom.getAttribute("icon") === "wishlist-active";

		if (this._onWishlist) {
			this._wishlistHeartDom.ocAriaLabel = "Artikel vom Merkzettel entfernen";
			this._wishlistHeartDom.icon = "wishlist-active";
		} else {
			this._wishlistHeartDom.ocAriaLabel = "Artikel merken";
			this._wishlistHeartDom.icon = "wishlist";
		}
	}

	addClickHandlerForWishlistBtn() {
		this.wishlistHeartDom.addEventListener("click", this._toggleHeartWishlistHeartOnClick());
	}

	_toggleHeartEnabled(heartBtn, enabled, initialSetup) {
		const defaultClasses = "combo_article--wishlistheart";
		if (!initialSetup) {
			if (enabled) {
				/*                                                      */
				heartBtn.className = defaultClasses;
				heartBtn.selected = true;
				heartBtn.icon = "wishlist-active";
				heartBtn.iconColor = "var(--oc-semantic-color-brand)";
				heartBtn.ocAriaLabel = "Artikel vom Merkzettel entfernen";
			} else {
				heartBtn.className = defaultClasses;
				heartBtn.selected = false;
				heartBtn.icon = "wishlist";
				heartBtn.iconColor = "unset";
				heartBtn.ocAriaLabel = "Artikel merken";
			}
		} else {
			if (enabled) {
				heartBtn.className = defaultClasses;
				heartBtn.selected = false;
				heartBtn.icon = "wishlist";
				heartBtn.iconColor = "unset";
				heartBtn.ocAriaLabel = "Artikel merken";
			}
		}
	}

	_toggleHeartWishlistHeartOnClick() {
		const self = this;
		return async function (event) {
			event.stopPropagation(); /*                                                       */
			self.onWishlist = !self.onWishlist;
			self._toggleHeartEnabled(self.wishlistHeartDom, self.onWishlist, false);
			const addedFrom = self._getWishListAddEventAddedFrom(self);
			if (self.onWishlist) {
				await self.wishlist.addItem(self.variationId, self.variationsForArticle.length === 1, addedFrom);
			} else {
				self.variationsForArticle.map(async variationId => {
					await self.wishlist.deleteItem(variationId, addedFrom);
				});
			}
		};
	}

	_getWishListAddEventAddedFrom(self) {
		return self.isArticleInTopicPage ? `SingleComboTopic` : `SingleCombo${self.comboType}`;
	}

	getDom() {
		return this.dom;
	}

	getId() {
		return this.id;
	}

	getVariationId() {
		return this.variationId;
	}

	getPosition() {
		return this.position;
	}

	get variationsForArticle() {
		return this._variationsForArticle;
	}

	get onWishlist() {
		return this._onWishlist;
	}

	set onWishlist(value) {
		this._onWishlist = value;
	}

	get wishlistHeartDom() {
		return this._wishlistHeartDom;
	}
}
